export const expenses = [
  {
    id: 1,
    description: "Description",
    amount: 15,
    category: "Transport",
    date: "15/12/2024",
  },
  {
    id: 4,
    description: "Description",
    amount: 120,
    category: "Transport",
    date: "16/12/2024",
  },
  {
    id: 2,
    description: "Description",
    amount: 5185,
    category: "Product",
    date: "12/12.2024",
  },
  {
    id: 3,
    description: "Description",
    amount: 570,
    category: "Accessories",
    date: "31/12/2024",
  },
  {
    id: 5,
    description: "Description",
    amount: 900,
    category: "Page",
    date: "31/12/2024",
  },
];
